export default "__VITE_ASSET__Bp0YOoqH__"